<template>
  <!--备份新闻列表（暂时使用修改的备份文件进行渲染）-->
  <div class="warpper">
    <el-skeleton v-if="newData.length" :rows="15" animated/>
    <template v-else>
      <div class="newType">
        <span class="newType_name">{{ newData.name }}</span>
        <div class="newType_rightBox" v-if="newData.articles?.length">
          <span @click="lookMore(newData)" class="newType_more">查看更多</span>
          <img src="../../../assets/recycling/news/more.svg" alt="">
        </div>
      </div>
      <div class="newDivider">
        <span class="newDivider_line"></span>
        <span class="newDivider_span"></span>
      </div>
      <div class="newBody" v-if="newData.articles?.length">
        <div class="newLeft">
          <div class="newLeft_content">
            <img class="newsLogo"
                 :src="newData.articles[0]?.coverImage? baseUrl+ newData.articles[0].coverImage : imgObj[newData.name]"
                 alt="">
            <div class="newsFirstTitle">
              <span :title="newData.articles[0].title"
                    @click="lookNews({breadList:[newData.name,newData.articles[0].title],newsId:newData.articles[0].id})">{{ newData.articles[0].title }}</span>
            </div>
          </div>
        </div>
        <div class="newRight">
          <template v-for="(item, index) in newData.articles">
            <div v-if="index !==0" class="newRight_content">
              <div class="newRight_content_left">
                <li class="newRight_content_left_name" :title="item.title"
                    @click="lookNews({breadList:[newData.name,item.title],newsId:item.id, parentId:item.columnIds})">
                  {{ item.title }}
                </li>
                <span class="newRight_content_left_time">{{ item.gmtCreated }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-else class="empty_box">
        <el-empty :image="require('@/assets/recycling/index/empty.svg')"></el-empty>
      </div>
    </template>
  </div>
</template>

<script>
import {scrollTop} from "@/util/scrollTop";

export default {
  name: 'newsList',
  props: {
    newData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      imgObj: {
        '行业动态': require('@/assets/recycling/news/IndustryTrends.jpg'),
        '政策新闻': require('@/assets/recycling/news/policyNews.jpg')
      }
    }
  },
  methods: {
    lookMore(item) {
      this.$emit('lookMore', {name: item.name, id: item.id, description: item.description});
    },
    lookNews(obj) {
      this.$emit('lookMyEyes', obj);
    }
  },
};
</script>

<style lang="less" scoped>
// 媒体查询：适配 768px 以下的移动端
@media screen and (max-width: 768px) {
  .newType {
    padding:0 4px 5px 4px;
    .newType_name {
      font-size: 18px !important;
    }
    .newType_more {
      font-size: 14px !important;
    }
  }
  .newDivider {
    margin: 0 4px;
  }
  .newBody {
    display: block !important;
    .newLeft {
      width: 100% !important;
      .newLeft_content {
        height: 200px !important;
        .newsFirstTitle {
          height: 50px !important;
          span {
            width: 100% !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical !important;
            -webkit-line-clamp: 2 !important;
            line-clamp: 2 !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            word-break: break-all !important;
            white-space: normal !important;
            font-size: 14px !important;
          }
        }
      }
    }

    .newRight {
      width: 100% !important;
      padding: 15px 0 0 0 !important;

      .newRight_content {
        margin-bottom: 8px !important;

        .newRight_content_left {
          display: block;

          .newRight_content_left_name {
            font-size: 14px !important;
            width:calc(100% - 90px) !important;
            margin-bottom: 2px !important;
            line-height:unset !important;
          }

          .newRight_content_left_time {
            width: 90px !important;
            font-size: 14px !important;
            justify-content: flex-start !important;
            line-height:unset !important;
          }
        }
      }
    }
  }

  .empty_box {
    padding: 0 10px;
  }
}

// 原有大屏样式保持不变
.warpper {
  font-family: "仿宋", "仿宋_GB2312", "FangSong", serif;
}

.newType {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .newType_name {
    font-size: 22px;
    font-weight: 700;
  }

  .newType_rightBox {
    display: flex;

    .newType_more {
      font-size: 18px;
      color: #95a1b7;
      cursor: pointer;
      margin-right: 10px;
    }

    .newType_more:hover {
      color: #1da1f2;
    }
  }
}

.newDivider {
  position: relative;
  height: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .newDivider_line {
    display: inline-block;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.2);
  }

  .newDivider_span {
    position: absolute;
    display: inline-block;
    width: 84px;
    height: 3px;
    opacity: 1;
    border-radius: 1.5px;
    background: rgba(21, 173, 97, 1);
  }
}

.newBody {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  padding: 0 20px;

  .newLeft {
    width: 30%;
  }

  .newRight {
    width: 70%;
  }

  .newLeft {
    .newLeft_content {
      height: 310px;
      width: 100%;
      position: relative;

      .newsLogo {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }

      .newsFirstTitle {
        position: absolute;
        width: 100%;
        height: 48px;
        left: 0;
        bottom: 0;
        display: flex;
        font-size: 18px;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.6);

        span {
          padding-left: 20px;
          font-size: 20px;
          color: #ffffff;
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }

        span:hover {
          color: #1da1f2;
          text-decoration: underline;
        }
      }
    }
  }

  .newRight {
    padding: 10px 0 0 20px;

    .newRight_content {
      width: 100%;
      display: flex;
      margin-bottom: 10px;

      .newRight_content_left {
        width: inherit;
        display: flex;

        .newRight_content_left_name {
          font-size: 22px;
          font-weight: 400;
          line-height: 24px;
          color: rgba(0, 0, 0, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 80%;
          cursor: pointer;
        }

        .newRight_content_left_time {
          width: 20%;
          display: flex;
          justify-content: end;
          font-size: 22px;
          font-weight: 400;
          letter-spacing: 0px;
          color: rgba(0, 0, 0, 0.6);
        }

        .newRight_content_left_box {
          display: flex;
          padding-left: 25px
        }

        .newRight_content_left_name:hover {
          color: #1da1f2;
        }

        .newRight_content_left_name::marker {
          color: rgba(143, 143, 143, 0.76);
        }

        .newRight_content_left_type,
        .newRight_content_left_time {
          font-size: 22px;
          line-height: 22px;
          color: rgb(149, 161, 183);
        }

        .newRight_content_left_time {
          margin-left: 20px;
        }
      }

      .newRight_content_right {
        flex: 10%;

        img {
          width: 100px;
          height: 52px;
        }
      }
    }
  }
}
</style>
